import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CrudService } from '../../../core/services/crud.service';
import { ApiResult } from '../../../shared/types/api-result.types';
import { EntityMinimalInfo } from '../../../shared/types/entity-minimal-info.types';
import { PaginatedResponse } from '../../../shared/types/paginated-response.types';
import {
    CreateShopDto,
    GetListShopsResponse,
    GetWarehousesForLookupResponse,
    Shop,
    ShopForLookupResponse,
    ShopTypeManageDto,
    UpdateShopDto,
} from './shops.types';

@Injectable({
    providedIn: 'root',
})
export class ShopsService extends CrudService<Shop, GetListShopsResponse, CreateShopDto, UpdateShopDto> {
    constructor(protected http: HttpClient) {
        super(http, 'shops');
    }

    getListTypes(
        take?: number,
        skip?: number,
        searchFilter?: string,
        sort?: { sortBy: string; sortOrder: string }
    ): Observable<ApiResult<PaginatedResponse<EntityMinimalInfo>>> {
        const params = this.transformGetListParams(take, skip, searchFilter, sort);

        return this.http
            .get<ApiResult<PaginatedResponse<EntityMinimalInfo>>>(`${this.restApiUrl}types`, { params })
            .pipe(catchError(this.handleError));
    }

    getLookup(
        take?: number,
        skip?: number,
        searchFilter?: string,
        sort?: { sortBy: string; sortOrder: string },
        includeDefaultWarehouse?: boolean
    ): Observable<ApiResult<PaginatedResponse<ShopForLookupResponse>>> {
        let params = this.transformGetListParams(take, skip, searchFilter, sort);
        if (includeDefaultWarehouse != null) {
            params.includeDefaultWarehouse = includeDefaultWarehouse;
        }

        return this.http
            .get<ApiResult<PaginatedResponse<ShopForLookupResponse>>>(`${this.bffApiUrl}lookup`, { params })
            .pipe(catchError(this.handleError));
    }

    getWarehousesLookup(
        take?: number,
        skip?: number,
        searchFilter?: string,
        sort?: { sortBy: string; sortOrder: string },
        isValid?: boolean,
        shopId?: number
    ): Observable<ApiResult<PaginatedResponse<GetWarehousesForLookupResponse>>> {
        let params = this.transformGetListParams(take, skip, searchFilter, sort, isValid);
        if (shopId != null) {
            params.shopId = shopId;
        }

        return this.http
            .get<
                ApiResult<PaginatedResponse<GetWarehousesForLookupResponse>>
            >(`${this.bffApiUrl}warehouses/lookup`, { params })
            .pipe(catchError(this.handleError));
    }

    public bulkManageShopTypes(dto: ShopTypeManageDto): Observable<ApiResult<void>> {
        return this.http.post<ApiResult<void>>(`${this.bffApiUrl}types/bulk`, dto).pipe(catchError(this.handleError));
    }
}
